/**
 * Chevron Icon
 * 
 * Directional chevron for pagination and navigation.
 * Based on Figma design specs.
 */

import { cn } from '@/lib/utils';

interface ChevronIconProps {
  direction?: 'left' | 'right';
  className?: string;
  'aria-hidden'?: boolean;
}

export function ChevronIcon({ 
  direction = 'right', 
  className,
  'aria-hidden': ariaHidden = true,
}: ChevronIconProps) {
  return (
    <svg 
      width="8" 
      height="14" 
      viewBox="0 0 8 14" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={cn(
        direction === 'left' && 'rotate-180',
        className
      )}
      aria-hidden={ariaHidden}
    >
      <path 
        d="M7.69885 6.6441L1.36128 13.0521C1.04232 13.3746 0.518681 13.3656 0.211017 13.0323C-0.0760668 12.7213 -0.0693892 12.2399 0.226211 11.937L5.39116 6.6441L0.22621 1.35119C-0.0693902 1.04827 -0.0760678 0.566935 0.211016 0.255928C0.51868 -0.0773748 1.04231 -0.0863963 1.36128 0.23611L7.69885 6.6441Z" 
        fill="currentColor"
      />
    </svg>
  );
}


